import { AfterViewInit, Directive, ElementRef, Input, Renderer2 } from '@angular/core';
import { startWith } from 'rxjs';
import { WindowService } from '../../services/window.service';

@Directive({
  selector: '[bsAutoAbbrev]',
})
export class AutoAbbrevDirective implements AfterViewInit {

  @Input() hasCustomDom?: boolean;

  constructor(
    private readonly elementRef: ElementRef<HTMLSpanElement>,
    readonly windowService: WindowService,
    private readonly renderer: Renderer2
  ) { }

  ngAfterViewInit(): void {
    if (this.hasCustomDom) return;

    this.windowService.windowSize$
      .pipe(startWith(window.innerWidth))
      .subscribe(() => {
        const nativeElementOffsetWidth =
          this.elementRef.nativeElement.offsetWidth;
        const nativeElementChildren = this.elementRef.nativeElement
          .children[0] as HTMLElement;
        if (!nativeElementChildren?.offsetWidth) return;

        const nativeElementChildrenOffsetWidth =
          nativeElementChildren.offsetWidth;
        const abbr$ = `<abbr title="${nativeElementChildren.innerText}">${nativeElementChildren.innerText}</abbr>`;

        if (nativeElementOffsetWidth < nativeElementChildrenOffsetWidth) {
          this.renderer.setProperty(nativeElementChildren, 'innerHTML', abbr$);
          return;
        }

        if (!nativeElementChildren.children[0]) return;

        const abbr = nativeElementChildren.children[0] as HTMLSpanElement;

        this.renderer.setProperty(
          nativeElementChildren,
          'innerHTML',
          abbr.innerText
        );
      });
  }
}
